import {gsap} from "gsap";
import SplitText from "../gsap/SplitText.min";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


var pageIntro = jQuery('section:first-of-type');
var pageIntroTitle = jQuery('h1');

if(pageIntroTitle.length > 0) {
    var pageIntroTitleSplit = new SplitText(pageIntroTitle, {type: 'lines'})
    var title = pageIntroTitleSplit.lines

    var timelineIntro = gsap.timeline();
    timelineIntro.set(pageIntro, {
        opacity: 1,
    })
    .to(title, 1, {
        stagger: .05,
        y: 0,
        opacity: 1,
        ease: 'power2.inOut',
    })
;

}
// gsap.to(pageIntro,0,{
//     opacity: 1,
// });
// gsap.from(title, 1,{
//     stagger: .05,
//     y: 48,
//     //delay: .4,
//     opacity: 0,
//     ease: 'power2.inOut',
// });



var playbutton = gsap.utils.toArray('.section--hero__media--play, .plus-small');
playbutton.forEach((elem, i) => {

    gsap.from(elem, 1.4,{
        scrollTrigger: {
            trigger: elem,
            //markers: true,
        },
        scale: 1.2,
        opacity: 0,
        delay: .8
    });

});

if (jQuery('.visual__image').length > 0) {
    var visual = gsap.utils.toArray('.visual__image');
    visual.forEach((elem, i) => {

        gsap.to(elem, 2, {
            scrollTrigger: {
                trigger: elem,
                start: 'top 85%',
                //markers: true,
            },
            scale: 1,
            opacity: 1,
            delay: .6
        });

    });
}


var paragraphs = gsap.utils.toArray('.wysiwyg > *, .section--split-text__heading, .fade-in-up-single');
paragraphs.forEach((elem, i) => {

    gsap.from(elem, .3,{
        scrollTrigger: {
            trigger: elem,
            start: 'top 85%',
            //markers: true,
        },
        y: 32,
        opacity: 0,
        delay: .1
    });

});

ScrollTrigger.batch(".fade-in-stagger > *, .section--culture__cards .section--culture__cards--item, .faqs .faq", {
    once: true,
    start: 'top 85%',
    onEnter: elements => {
        gsap.to(elements, {
            delay: .1,
            autoAlpha: 1,
            y: 0,
            stagger: 0.15
        });
    },
});

ScrollTrigger.batch(".section--stats__stats > *, .section--stats-two__stats-wrapper > *", {
    once: true,
    start: 'top 85%',
    onEnter: elements => {
        gsap.to(elements, {
            delay: .1,
            autoAlpha: 1,
            x: 0,
            stagger: 0.15
        });
    },
});


ScrollTrigger.batch(".fade-in-stagger-delay > *", {
    once: true,
    start: 'top 85%',
    onEnter: elements => {
        gsap.to(elements, {
            delay: .6,
            autoAlpha: 1,
            y: 0,
            stagger: 0.15
        });
    },
});

if (jQuery('.section--hero__media').length > 0) {
    var imageSlide = gsap.utils.toArray('.section--hero__media');
    imageSlide.forEach((elem, i) => {

        var imageAnimate = elem;
        var imageSlideImage = elem.querySelector('.section--hero__media-image');
        var imageBoxSlideWrapper = elem.querySelector('picture');

        var timeline = gsap.timeline({
            delay: .1,
            scrollTrigger: {
                trigger: elem,
                start: 'top 75%',
                // end: 'bottom 75%',
                //markers: true,
            }
        });
        timeline.to(imageBoxSlideWrapper, 1, {
            //height: '100%',
            webkitClipPath: 'polygon(0px 0%, 100% 0%, 100% 100%, 0% 100%)',
            clipPath: 'polygon(0px 0%, 100% 0%, 100% 100%, 0% 100%)',
            ease: 'power2.inOut',
        }, 'initial')
            .from(imageSlideImage, 1.6, {
                scale: 1.2,
                ease: 'power2.inOut',
            }, 'initial')
        ;
    })
}




// const counters = document.querySelectorAll('.section--stats__stats__stat--fact');
// const speed = 200;
//
// counters.forEach( counter => {
//     const animate = () => {
//         const value = +counter.getAttribute('data-value');
//         const data = +counter.innerText;
//
//         const time = value / speed;
//         if(data < value) {
//             counter.innerText = Math.ceil(data + time);
//             setTimeout(animate, 25);
//         } else {
//             counter.innerText = value;
//         }
//
//     }
//
//     animate();
// });

// var labels = gsap.utils.toArray('.section--labels__inner');
// labels.forEach((elem, i) => {
//
//     var labels 		       = elem.querySelector('.label-items');
//
//     gsap.from(labels, 1.2,{
//         scrollTrigger: {
//             trigger: elem,
//             start: 'top 85%',
//             //markers: true,
//         },
//         stagger: .2,
//         y: 24,
//         opacity: 0,
//         delay: .4
//     });
//
// });
